import { Link } from "react-router-dom";
import type { MangaComic } from "../../mocks/manga";

export default function ComicCard({ comic }: { comic: MangaComic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <Link to={`/detail/${comic.id}`} className="relative block overflow-hidden" aria-label={`查看《${comic.title}》详情`}>
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 妖精漫画网`}
          className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
          {comic.status}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {comic.rating}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <Link to={`/detail/${comic.id}`} className="font-display text-lg leading-tight text-foreground-950 transition-colors hover:text-primary-600">
          {comic.title}
        </Link>
        <p className="mt-1 text-xs text-foreground-500">{comic.author} · {comic.chapters}话</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {comic.tags.slice(0, 3).map((tag) => (
            <Link
              key={tag}
              to={`/library?tag=${encodeURIComponent(tag)}`}
              className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
            >
              #{tag}
            </Link>
          ))}
        </div>
        <p className="mt-3 truncate text-xs text-foreground-500">{comic.latestChapter}</p>
      </div>
    </article>
  );
}